import React, {Component} from 'react'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'

import AddArtistIcon from '@material-ui/icons/AddCircle'

import PaperBlock from "../../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <ArtistsPanel artists onSelectArtistClick = {} onRemoveArtistClick = {template}/>
 */

class ArtistsPanel extends Component {

	render() {

		const {classes} = this.props

		return <PaperBlock style = {{padding: "0px", display: "flex", flexDirection: "column"}}>
			<div style={{margin: "10px"}}>
				<div style = {{width: "100%", display: "flex", alignItems: "center"}}>
					<Typography style = {{flex: "1 1 auto"}}>Ведущие</Typography>
					<Button
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onSelectArtistClick === "function") {
								this.props.onSelectArtistClick()
							}
						}}
					>
						<AddArtistIcon className = {classes.AddArtistIcon}/>
						Добавить ведущего
					</Button>
				</div>
				<div style = {{display: "flex", flexWrap: "wrap"}}>
					{this.props.artists.map(
						(artist, n) => <Chip
							className = {this.props.classes.Chip}
							key = {n}
							label = {artist.name}
							onDelete = {() => {
								if (typeof this.props.onRemoveArtistClick) {
									this.props.onRemoveArtistClick(artist)
								}
							}}
						/>
					)}
				</div>
			</div>
		</PaperBlock>
	}

}

export default withStyles(theme => ({
	AddArtistIcon: {
		marginRight: theme.spacing.unit,
	},
	Chip: {
		margin: theme.spacing.unit,
	}
}))(ArtistsPanel)
